import { render, staticRenderFns } from "./AddMoiPoiPointsModal.vue?vue&type=template&id=bcd42b1a&scoped=true&"
import script from "./AddMoiPoiPointsModal.vue?vue&type=script&lang=js&"
export * from "./AddMoiPoiPointsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMoiPoiPointsModal.vue?vue&type=style&index=0&id=bcd42b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd42b1a",
  null
  
)

export default component.exports